import { ErrorBoundary } from '@sentry/react';
import { useAtomValue } from 'jotai';
import { Navigate } from 'react-router-dom';
import { unwrappedNavigationTeamIdAtom } from '@/atoms/navigation';
import { useTeamNavigationNew } from '@/hooks/navigation/useTeamNavigation';
import { AppShellContentsNoTextLoadingFallback, AppShellErrorFallback } from '../layout/AppShellFallback';

// Rendered inside AppShell's outlet, so the side nav is already on screen — the
// fallbacks here must only fill the content area.
const RedirectToTeamBase = () => {
  const { datahubId } = useAtomValue(unwrappedNavigationTeamIdAtom);
  const newXpDefaultPath = useTeamNavigationNew();

  if (!datahubId) return <AppShellContentsNoTextLoadingFallback />;

  return (
    <AppShellContentsNoTextLoadingFallback>
      <Navigate to={`${newXpDefaultPath}dashboard`} replace />
    </AppShellContentsNoTextLoadingFallback>
  );
};

export const RedirectToTeam = () => (
  <ErrorBoundary fallback={<AppShellErrorFallback />}>
    <RedirectToTeamBase />
  </ErrorBoundary>
);
